import classNames from 'classnames'

export function HeaderBlock({ className, ...rest }) {
  return <div className={classNames('HeaderBlock', className)} {...rest} />
}
